<template>
  <div v-if="!isInAndroidApp"
    class="absolute-center-x fixed top-0 bottom-0 z-[99] overflow-hidden max-w-[var(--max-width)] w-full h-[100vh]">
    <!-- <div class="fixed inset-0 z-[99] overflow-hidden"> -->
    <Image class="size-full" fit="cover" :src="openningImage" v-if="openningImage" />
  </div>
</template>

<script setup lang="ts">
import { useOpenningImage } from '@/store'
import { isInAndroidApp } from '@/env'

const openningImage = computed(() => useOpenningImage().openningImage)
</script>